export default "__VITE_ASSET__6x1x26$M__"